import { ContentTypeVariations } from '@/components/organisms';

export function getCarouselBreakpoints(
  type: ContentTypeVariations | string,
): Record<number, { slidesPerView: number; spaceBetween: number }> {
  return {
    0: {
      slidesPerView: type === ContentTypeVariations.VIDEO ? 2 : 3,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: type === ContentTypeVariations.VIDEO ? 3 : 4,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: type === ContentTypeVariations.VIDEO ? 3 : 4,
      spaceBetween: 16,
    },
    1280: {
      slidesPerView: type === ContentTypeVariations.VIDEO ? 3 : 4,
      spaceBetween: 16,
    },
    1536: {
      slidesPerView: type === ContentTypeVariations.VIDEO ? 3 : 5,
      spaceBetween: 16,
    },
    1920: {
      slidesPerView: type === ContentTypeVariations.VIDEO ? 4 : 6,
      spaceBetween: 16,
    },
  };
}
